// extracted by mini-css-extract-plugin
module.exports = {"noResult":"styles_noResult__QrW0l","iconWrapper":"styles_iconWrapper__q_jDL","closeMenu":"styles_closeMenu__5BKtM"};